export default {
  init() {
    // JavaScript to be fired on all pages

    // Remove useless nodes
    function clean(node)
      {
        for(var n = 0; n < node.childNodes.length; n ++)
        {
          var child = node.childNodes[n];
          if
          (
            child.nodeType === 8 || (child.nodeType === 3 && !/\S/.test(child.nodeValue))
          )
          {
            node.removeChild(child);
            n --;
          }
          else if(child.nodeType === 1)
          {
            clean(child);
          }
        }
      }
    clean(document);

    // stop dummy links
    $('a[href="#"]').click(function(e){
      e.preventDefault();
    });

    // Toggle mobile button
    /*
    $('.hamburger').on('click', function(){
      $(this).toggleClass('hamburger--squeeze is-active');
    });
    */

    // matchHeight
    /*
    $('.related-post h4').matchHeight();
    $('.related-post p').matchHeight();

    $('.post-object h2').matchHeight();
    $('.post-object p').matchHeight();

    $('h4.name').matchHeight();
    */

    $('.carousel.multi-slide').on('slide.bs.carousel', function (e) {
      var $e = $(e.relatedTarget);
      var idx = $e.index();
      var itemsPerSlide = 5;
      var totalItems = $('.carousel-item').length;

      if (idx >= totalItems-(itemsPerSlide-1)) {
        var it = itemsPerSlide - (totalItems - idx);
        for (var i=0; i<it; i++) {
          // append slides to end
          if (e.direction == 'left') {
            $('.carousel-item').eq(i).appendTo('.carousel-inner');
          } else {
            $('.carousel-item').eq(0).appendTo('.carousel-inner');
          }
        }
      }
    });

    $('.carousel').swipe({
        swipe: function (event, direction, distance, duration, fingerCount, fingerData) {
          if (direction == 'left') $(this).carousel('next');
          if (direction == 'right') $(this).carousel('prev');
          console.log(fingerData);
        },
        allowPageScroll: 'vertical',
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js